// Mapping between page names and module names for permission checking
const pageToModuleMap = {
  dashboard: null, // Dashboard is always visible
  employees: "employees",
  payroll: "payroll",
  attendance: "attendance",
  reports: "reports",
  calendar: "calendar",
  messages: "messages",
  EscalationGroupMapping: "complaints",
  DocumentsManagement: "documents",
  LeaveApprovalPage: "leaves",
  AdvancementsManagement: "solfa",
  ChangesPage: "changesPage", // Employee changes uses separate changesPage module
  TaxCalculator: "payroll", // Tax calculator is part of payroll
  adminLevels: "adminLevels",
  departments: "departments",
  configuration: "configurations",
  Settings: "configurations",
};

export default pageToModuleMap;